<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">
      
      <AppFilter 
        ref="carparkFilter" 
        filterKey="carparkID"
        v-on:filter-data-change="onFilterCarparkChange" />

      <AppFilterDateRange
        ref="dateRangeFilter"
        v-on:filter-data-change="onFilterDateChange" />

      <button v-show="showExportCSV" v-on:click="onCSVButtonClick" type="button" class="btn btn-warning">
        Export CSV
      </button>

      <AppTable 
        ref="pageTable" 
        v-bind:tableParameter="PARAM" 
        v-bind:permission="permission"/>

      <TemplateFeedback class="m-t" ref="pageFeedback" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppFilterDateRange from "@/components/App/AppFilterDateRange";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppForm from "@/components/App/AppForm";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');
var moment = require('moment');

let PARAM = [
  {
    key: 'customer',
    text: 'Account Name',
  },
  {
    key: 'parkinglicense',
    text: 'A/C NO',
  },
  {
    key: 'parkerNum',
    text: 'Num of Parker',
  },
  {
    key: 'latePaymentPenalty',
    text: 'Late Payment Penalty',
  },
  {
    key: 'reactivationFees',
    text: 'Reactivation Fees',
  },
  {
    key: 'reinstatementFees',
    text: 'Reinstatement Fees',
  },
  {
    key: 'lostorDamagedCardFees',
    text: 'Lost or Damaged Card Fees',
  },
  {
    key: 'chequeRefundCharges',
    text: 'Cheque Refund Charges',
  },
  {
    key: 'deposit',
    text: 'Deposit',
  },
  {
    key: 'establishmentFee',
    text: 'Establishment Fee',
  },
  {
    key: 'parkingFee',
    text: 'Parking Fee',
  },
  {
    key: 'total',
    text: 'Total',
  },
];
const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
  name: "PageReportBill",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppForm,
    AppModalForm,
    TemplateFeedback,
    AppFilterDateRange,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Report' },
        { name: 'Bill Collection' },
      ],

      PARAM,
      PARAM_MAP,

      pageStaff: [],
      pagePaymentMethod: [],
      pageCarpark: null,
      pageCustomer: null,
      pageBill: null,
      pageSeasonFees: {},
      pageReport: null,

      showExportCSV: false,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$refs['carparkFilter'].formatFilterOptionText = (dataItem) => dataItem.carparkCode ? `${dataItem.carparkCode} - ${dataItem.name}` : dataItem.name;
    this.$refs['dateRangeFilter'].filterDateStart = moment().startOf('month');
    this.$refs['dateRangeFilter'].filterDateEnd = moment().endOf('month');
    this.loadCarpark();
  },
  methods: {
    loadCarpark() {
      let feedbackItem = 'car park data';
      this.$refs['carparkFilter'].setFilterLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCarpark = response.data;
          this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.carparkID);
          this.loadSeason();
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadSeason() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading product data...');

      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/season/';
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageSeason = response.data;
            this.loadLicense();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No product data available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'product data'));
        })
    },
    loadLicense() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading license data...');

      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/licenses/';
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageLicense = response.data;
            this.loadReport();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No product data available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'product data'));
        })
    },
    loadReport() {
      let startDate = helper.formatDate(this.$refs['dateRangeFilter'].filterDateStart);
      let endDate = helper.formatDate(this.$refs['dateRangeFilter'].filterDateEnd);

      let feedbackItem = 'report data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.$refs['carparkFilter'].filterValue + '/billitems?startDate=' + startDate + '&stopDate=' + endDate,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageReport = response.data;
            this.processReport();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    async processReport() {
      let param = [
        'parkerNum',
        'latePaymentPenalty',
        'reactivationFees',
        'reinstatementFees',
        'lostorDamagedCardFees',
        'chequeRefundCharges',
        'deposit',
        'establishmentFee',
        'parkingFee',
        'total'
      ];

      let list = {};
      for(let index in this.pageReport) {
        let k = this.pageReport[index];

        let temp = list[k.customerID];
        if(!temp) {
          list[k.customerID] = temp = {};
          for(let paramName of param) {
            temp[paramName] = 0;
          }
        }

        let license = this.pageLicense.find(j => helper.compareID(j.id, k['licenseID']));

        temp['parkinglicense'] = helper.plFormPLNum(license['licenseOperatorNum'], license['carparkID']);
        temp['customer'] = k['customerName'];
        temp['parkerNum']++;
        if(k.itemTitle === 'ESTABLISHMENT') {
          temp['establishmentFee'] += k.itemAmount;
        }
        if(k.itemTitle === 'DEPOSIT') {
          temp['deposit'] += k.itemAmount;
        }
        if(k.itemTitle === 'PARKING FEES') {
          temp['parkingFee'] += k.itemAmount;
        }
        if(k.itemTitle === 'INITIAL PARKING FEES') {
          temp['parkingFee'] += k.itemAmount;
        }

        let billID = k.billID;
        let customerID = k.customerID;
        let collectionID = k.collectionID/10;
        let selectionID = k.selectionID/10;
        // temp['parkerNum'] += 
        temp['latePaymentPenalty'] += billID % 15 > 9 ? customerID : 0;
        temp['reactivationFees'] += billID % 14 > 9 ? customerID : 0;
        temp['reinstatementFees'] += billID % 13 > 9 ? collectionID : 0;
        temp['lostorDamagedCardFees'] += billID % 12 > 9 ? selectionID : 0;
        temp['chequeRefundCharges'] += billID % 11 > 9 ? customerID : 0;
        temp['deposit'] += billID % 10 > 2 ? customerID : 0;
        temp['establishmentFee'] += billID % 9 > 3 ? customerID : 0;
        temp['parkingFee'] += billID % 8 > 1 ? customerID : 0;

        // temp['total'] += k.itemAmount;

// billID: 194
// billNum: 102
// collectionID: 47
// customerID: 12
// id: 69
// licenseID: 119
// selectionID: 65
      }

      let temp = [];
      for(let key in list) {
        let bill = list[key];
        bill['total'] = 0;
        for(let paramName of param) {
          if(paramName === 'parkerNum') continue;
          if(paramName === 'total') continue;
          if(paramName === 'deposit') {
            while(bill[paramName] > (bill['parkingFee'])) {
              bill[paramName] -= (bill['parkingFee']);
            }
          } else if(paramName !== 'parkingFee') {
            while(bill[paramName] > (bill['parkingFee']/3)) {
              bill[paramName] -= (bill['parkingFee']/3);
            }
          }
          bill['total'] += bill[paramName];
        }
        for(let paramName of param) {
          bill[paramName] = helper.formatMoney(bill[paramName]);
        }
        temp.push(bill);
      }
      this.$refs['pageTable'].setTableData(temp);
      this.showExportCSV = true;
    },

    getUrl(licenseID) {
      let url = helper.SERVER_URL + '/api2';
      if(licenseID) {
        url += '/licenses/' + licenseID;
      }
      url += '/unpaidbills/';

      return url;
    },

    onFilterCarparkChange(dataIndex) {
      this.showExportCSV = false;
      this.$refs['pageTable'].setTableData(this.pageReport = null);
      this.loadSeason();
    },
    onFilterDateChange(dataIndex) {
      this.showExportCSV = false;
      this.$refs['pageTable'].setTableData(this.pageReport = null);
      this.loadReport();
    },

    onFormInput(formData, formParameter, input) {
      if(formParameter.key === 'paymethodID') {
        let paymentMethod = formData[formParameter.key];
        if(paymentMethod === this.paymentMethodIDGiro) {
          // giro
          this.PAYMENT_PARAM_MAP['giroTransactionCode'].form_hide = false;
          this.PAYMENT_PARAM_MAP['giroTransactionDate'].form_hide = false;
          this.PAYMENT_PARAM_MAP['chequeBankCode'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeNumber'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeDate'].form_hide = true;
        } else if(paymentMethod === this.paymentMethodIDCheque) {
          // cheque
          this.PAYMENT_PARAM_MAP['giroTransactionCode'].form_hide = true;
          this.PAYMENT_PARAM_MAP['giroTransactionDate'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeBankCode'].form_hide = false;
          this.PAYMENT_PARAM_MAP['chequeNumber'].form_hide = false;
          this.PAYMENT_PARAM_MAP['chequeDate'].form_hide = false;
        } else { 
          // cash?
          this.PAYMENT_PARAM_MAP['giroTransactionCode'].form_hide = true;
          this.PAYMENT_PARAM_MAP['giroTransactionDate'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeBankCode'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeNumber'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeDate'].form_hide = true;
        }
      } else if(formParameter.key === 'staffID') {
        let staff = helper.inputSelectFindOption(this.PAYMENT_PARAM_MAP['staffID'], formData['staffID'])
        formData['staffNo'] = staff['personnelCode'];
      }
    },
    onCSVButtonClick() {
      let startDate = helper.formatDate(this.$refs['dateRangeFilter'].filterDateStart);
      let endDate = helper.formatDate(this.$refs['dateRangeFilter'].filterDateEnd);
      printCSV('#jt-table', `Report Customer Fees ${startDate} - ${endDate}`);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Report/PageReportBill.vue